import _styled from "@emotion/styled/base";
import React, { useState, forwardRef } from 'react';
import { useTranslate } from 'react-polyglot';
import Field from '../../Field';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StyledInput = /*#__PURE__*/_styled("input", {
  target: "e4jt8f0",
  label: "StyledInput"
})("color:", ({
  theme
}) => theme.color.highEmphasis, ";background:none;border:none;outline:none;width:calc(100% + 32px);font-family:inherit;font-size:", ({
  title
}) => title ? '2rem' : '1rem', ";font-weight:", ({
  title
}) => title ? 'bold' : 'normal', ";letter-spacing:", ({
  title
}) => title ? '-0.5px' : '0', ";line-height:1rem;caret-color:", ({
  theme,
  error
}) => error ? theme.color.danger['900'] : theme.color.primary['800'], ";margin:-2rem -1rem -1rem -1rem;padding:2rem 1rem 1rem 1rem;", ({
  clickable
}) => clickable ? `cursor: pointer;` : ``, " ::placeholder{color:", ({
  theme
}) => theme.color.disabled, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const TextField = /*#__PURE__*/forwardRef(({
  name,
  label,
  icon,
  description,
  status,
  onChange,
  onClick,
  readOnly,
  placeholder,
  children,
  value,
  focus,
  title,
  type,
  password,
  className,
  filled,
  error,
  errors
}, ref) => {
  const [inputFocus, setInputFocus] = useState();
  const t = useTranslate();
  return ___EmotionJSX(Field, {
    onClick: onClick,
    label: label,
    labelTarget: name,
    description: description,
    status: status,
    focus: focus || inputFocus,
    className: className,
    filled: filled,
    error: error,
    errors: errors,
    icon: icon,
    clickable: !readOnly
  }, ___EmotionJSX(StyledInput, {
    ref: ref,
    clickable: readOnly && !!onClick,
    onClick: onClick,
    readOnly: readOnly,
    type: password ? 'password' : type ? type : 'text',
    autoFocus: focus,
    id: name,
    name: name,
    placeholder: placeholder ? placeholder : label ? t('editor.editorControl.field.placeholder', {
      fieldLabel: label.toLowerCase()
    }) : '',
    value: value || '',
    onChange: e => onChange(e),
    onFocus: () => setInputFocus(true),
    onBlur: () => setInputFocus(false),
    autoComplete: "off",
    title: title,
    error: error
  }), children && children);
});
TextField.displayName = 'TextField';
export default TextField;